export const isMakePorsche = make => make?.toLowerCase() === 'porsche';
export const isVehicleMakePorsche = vehicle => isMakePorsche(vehicle?.vehicleInfo?.styleInfo?.make);
